// extracted by mini-css-extract-plugin
export default {"lightFontColor":"#eee","darkFontColor":"#222"};